export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false
};
export const PageName = '共富启航战略部署';